import { render, staticRenderFns } from "./servicesinfo.vue?vue&type=template&id=48b86340"
import script from "./servicesinfo.vue?vue&type=script&lang=js"
export * from "./servicesinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports